/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import Vue from 'vue';
import sortBy from 'lodash/sortBy';
import groupBy from 'lodash/groupBy';
import uniq from 'lodash/uniq';
import cacheAxios from '../../util/cacheAxios';

const ugradsAxios = axios.create();
const cache = new Map();
cacheAxios(ugradsAxios, cache);
ugradsAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });
const legendRef = {
  bottom: '10%',
  right: '1%',
  orient: 'vertical',
  align: 'right',
};

export default {
  state: {
    UniGradsYearSelected: [],
    UniGradsYears: [],
    UniGradsCountries: [],
    UniGradsCStates: [],
    filteredUniversities: [],
    filteredCourses: [],
    filteredData: [],
  },
  mutations: {
    setUniGradsYears(state, years) {
      state.UniGradsYears = years;
      state.UniGradsYearSelected = years[years.length - 1];
    },
    setUniGradsCountries(state, countries) {
      state.UniGradsCountries = countries;
    },
    setUniGradsCStates(state, cstates) {
      state.UniGradsCStates = cstates;
    },
    setUniGradsUnisByLoc(state, universities) {
      state.filteredUniversities = universities;
      state.filteredData = universities;
    },
    setUniGradsDisiplineByYear(state, datas) {
      state.filteredCourses = datas;
    },
    setUniGradsData(state, datas) {
      state.filteredData = datas;
    },
  },
  actions: {
    initUniGradsCountries({
      commit,
    }) {
      let distincturl = '/aims/api/unigrads/discipline/';
      let allurl = '/aims/api/unigrads/available/';
      let uYear = '';
      ugradsAxios.get('/aims/api/unigrads/years')
        .then((res) => {
          if (res.data) {
            commit('setUniGradsYears', res.data);
            uYear = res.data[res.data.length - 1];
            distincturl = distincturl.concat(uYear);
            ugradsAxios.get(distincturl)
            .then((resc) => {
              if (resc.data) {
                commit('setUniGradsDisiplineByYear', resc.data);
              }
            });
            allurl = allurl.concat(uYear);
            ugradsAxios.get(allurl)
            .then((resc) => {
              if (resc.data) {
                commit('setUniGradsData', resc.data);
              }
            });
          }
        });
    },
    filterCountry({
      commit,
    }, theFilter) {
      return ugradsAxios.post('/aims/api/unigrads/countries', theFilter)
        .then((res) => {
          if (res.data) {
              commit('setUniGradsCountries', res.data);
            } else {
              commit('setUniGradsCountries', []);
            }
        });
    },
    filterCState({
      commit,
    }, theFilter) {
      return ugradsAxios.post('/aims/api/unigrads/cstates', theFilter)
        .then((res) => {
          if (res.data) {
            commit('setUniGradsCStates', res.data);
          } else {
            commit('setUniGradsCStates', []);
          }
        });
    },
    filterUnisByLoc({
      commit,
    }, theFilter) {
      return ugradsAxios.post('/aims/api/unigrads/universities', theFilter)
        .then((res) => {
          if (res.data) {
            commit('setUniGradsUnisByLoc', res.data);
          } else {
            commit('setUniGradsUnisByLoc', []);
          }
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/unigradsModule.js